import React from 'react';
import { inject, observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';

import featureFlag from 'tm3-core/stores/feature-store';
import Icon from 'bz-icons/src/controls/icon';
import GUID from 'bz-utilities/modules/variables/guid';

import ReportsMenu from './controls/reports-menu';
import './style.styl';

import { Button } from '@material-ui/core';

interface IProps {
  clinicalStore?: any;
}

@inject('clinicalStore')
@observer
class Footer extends React.Component<IProps> {
  @observable open = true;

  render() {
    if (!this.show) {
      return null;
    }

    return (
      <div className="clinical-pronto-footer">
        <div className="nowrap flex-row">
          <div className="icon flex-none">
            <Icon width={24} height={24} value="0551_information_about" />
          </div>
          <div className="flex-both">
            <span>This case has been referred by: </span>
            <span className="name">{this.name}</span>
          </div>
          <div className="flex-none">
            <ReportsMenu />
          </div>
          <div className="flex-none">
            <Button variant={'outlined'} onClick={this.onClose}>
              <Icon width={16} height={16} value="0060_error_warning_danger_stop_delete_exit" />
              <span>Hide</span>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  @computed
  get allowed() {
    let { prontoStore } = this.props.clinicalStore;
    return !!Array.from(prontoStore.allowed.values()).find((x) => GUID.hasValue(x));
  }

  @computed
  get show() {
    let { details, referralStore } = this.props.clinicalStore.caseStore;
    let { closed, bookingAuditId } = details || {};

    if (!this.open) {
      return false;
    }

    const isProntoReport = featureFlag.prontoIntegrationEnabled && GUID.hasValue(bookingAuditId);
    const canReportToPronto = !!referralStore && referralStore.referral.canReport;
    return !closed && isProntoReport && !!this.allowed && !!canReportToPronto;
  }

  @computed
  get name() {
    return this.props.clinicalStore.prontoStore.name;
  }

  @action.bound
  onClose() {
    this.open = false;
  }
}

export default Footer;
